import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation",
  "use": "navigation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"navigation\"><path d=\"M24 9.844l-3.583 6.781L19.333 14c-4.05 2.278-5.11 5.961-5.333 10h-4c.189-5.147 1.358-10.246 7.75-13.875L16.709 7.5 24 9.844zm-13.242 3.975C9.66 12.478 8.2 11.233 6.25 10.125L7.291 7.5 0 9.844l3.583 6.781L4.667 14c2.018 1.135 3.293 2.62 4.093 4.323a15.463 15.463 0 0 1 1.998-4.504zM12 0L7 5h3v5.267a16.314 16.314 0 0 1 2.011 1.936A16.22 16.22 0 0 1 14 10.267V5h3l-5-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol